// ABOUTME: Holds the on/off state of the live page editor so the runtime applier can stand aside while editing.
// ABOUTME: State only — the editing UI itself is lazy-loaded by the floating admin button.

import { createContext, useContext, useState, type ReactNode } from 'react';

interface LiveEditorContextValue {
  editing: boolean;
  setEditing: (editing: boolean) => void;
}

const LiveEditorContext = createContext<LiveEditorContextValue>({
  editing: false,
  setEditing: () => {},
});

export const LiveEditorProvider = ({ children }: { children: ReactNode }) => {
  const [editing, setEditing] = useState(false);
  return (
    <LiveEditorContext.Provider value={{ editing, setEditing }}>
      {children}
    </LiveEditorContext.Provider>
  );
};

export const useLiveEditor = () => useContext(LiveEditorContext);
